// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"948efa46","57":"6d0f770a","359":"6d0f770a","456":"6d0f770a","564":"6d0f770a","623":"efc0f0a2","626":"6d0f770a","635":"06cca9f2","763":"6d0f770a","955":"6d0f770a"}[chunkId] + ".chunk.css";
};